export const SELECT_PROMO_CODE = 'ADMIN/SELECT_PROMO_CODE';

export interface AdminDispatchTypes {
  type: string;
  payload?: any;
}